import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv";
import { Box, Button } from "@mui/material";


const UsrListMnT = () => {
    const navigate = useNavigate();
    const [usersData, setUsersData] = useState([]);
    const [deleteCode, setDeleteCode] = useState({});
    const [isFetching, setIsFetching] = useState(true);
    const [editData, setEditData] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [viewData, setViewData] = useState(null);

    // Function to get role name from role code
    const getRoleName = (roleCode) => {
        const roleMap = {
            '1': 'Central Admin',
            '2': 'State Admin',
            '3': 'District Admin',
            '5': 'Surveyor',
            '6': 'FMTTI Admin',
            '7': 'FMTC Admin',
            '8': 'FMTC Surveyor',
            '9': 'ICAR Admin',
            '10': 'Atari Admin',
            '11': 'KVK Admin',
            '12': 'CRM Surveyor'
        };
        return roleMap[roleCode] || 'Unknown Role';
    };

    useEffect(() => {
        // Debug session storage values

        fetchData();
        const schemeCode = sessionStorage.getItem("schemeCodeModel") || "16";
    }, []);

    useEffect(() => {

    }, [usersData]);

    const fetchData = async () => {
        // Get session storage values with better error handling
        const userCode = sessionStorage.getItem("userCodeModel");
        const userRoleCode = sessionStorage.getItem("userRoleCodeModel"); // This is userole
        const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel") || "16";
        
        console.log("Session values:", {
            userCode,
            userRoleCode,
            userTypeCode,
            schemeCode
        });


        // Validate essential session values
        if (!userCode || userCode === "null" || userCode === "undefined") {
            console.error("Invalid userCode in session storage:", userCode);
            alert("Session expired. Please login again.");
            navigate("/mapLogin");
            return;
        }

        if (!userRoleCode || userRoleCode === "null" || userRoleCode === "undefined") {
            console.error("Invalid userRoleCode in session storage:", userRoleCode);
            alert("Session expired. Please login again.");
            navigate("/mapLogin");
            return;
        }

        try {
            const baseUrl = process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE;
            let result;

            // Simplified API call logic
            try {


                // Use the new endpoint for all users
                const apiUrl = `${baseUrl}/api/MT/GetUsersDetailsCreatedBy`;

                result = await axios({
                    method: 'post',
                    url: apiUrl,
                    headers: {
                        'accept': '/',
                        'Content-Type': 'application/json'
                    },
                    data: {
                        createdBy: parseInt(userCode)
                    }
                });


            } catch (error) {
                console.error("API call failed:", error.message);
                if (error.response) {
                    console.error("Response data:", error.response.data);
                    console.error("Response status:", error.response.status);
                }
                throw error; // Re-throw to be caught by outer catch block
            }

            // Process the response
            if (result?.data?.success === true) {
                console.log("=== Processing Successful Response ===");

                if (Array.isArray(result.data.dataContent)) {
                    let filteredUsers = result.data.dataContent;
                    const totalUsers = filteredUsers.length;
                    console.log("Total users before filtering:", totalUsers);
                    console.log("Sample user data:", filteredUsers[0]);

                    // Apply role-based filtering
                    if (userRoleCode === "1") {
                        // Central users can see all users
                        console.log("Central user - showing all users");
                    } else if (userRoleCode === "2") {
                        // State users can see all users in their state
                        const userState = sessionStorage.getItem("stateNameModel");
                        filteredUsers = filteredUsers.filter(user => {
                            const matchesState = user.stateCode && user.stateCode.toString() === userState;
                            if (!matchesState) {
                                console.log(`Filtering out user ${user.userName} - state mismatch`);
                            }
                            return matchesState;
                        });
                        console.log("State user - filtered by state:", filteredUsers.length);
                    } else if (userRoleCode === "3") {
                        // District users can see users in their district
                        const userDistrict = sessionStorage.getItem("districtCodeModel");
                        filteredUsers = filteredUsers.filter(user => {
                            const matchesDistrict = user.districtCode && user.districtCode.toString() === userDistrict;
                            return matchesDistrict;
                        });
                        console.log("District user - filtered by district:", filteredUsers.length);
                    } else if (userRoleCode === "6") {
                        // FMTTI users can see FMTC users
                        filteredUsers = filteredUsers.filter(user => user.userRoleCode === "7");
                        console.log("FMTTI user - filtered to FMTC users:", filteredUsers.length);
                    } else if (userRoleCode === "7") {
                        // FMTC users can see FMTTI_Surveyor users
                        filteredUsers = filteredUsers.filter(user => user.userRoleCode === "8");
                        console.log("FMTC user - filtered to FMTTI_Surveyor users:", filteredUsers.length);
                    }

                    console.log("=== Final Results ===");
                    console.log("Users to display:", filteredUsers.length);

                    if (filteredUsers.length > 0) {
                        console.log("Sample user data:", filteredUsers[0]);
                        setUsersData(filteredUsers);
                    } else {
                        console.log("No users found after filtering. Showing debug info...");
                        console.log("All users from API:", result.data.dataContent.map(user => ({
                            userName: user.userName,
                            userCode: user.userCode,
                            userRoleCode: user.userRoleCode,
                            stateCode: user.stateCode,
                            districtCode: user.districtCode,
                            userTypeCode: user.userTypeCode
                        })));

                        // Set all users without filtering for debugging
                        setUsersData(result.data.dataContent);
                    }
                } else {
                    console.error("API Response dataContent is not an array:", result.data.dataContent);
                    setUsersData([]);
                    alert("Invalid data format received from server.");
                }
            } else {
                console.error("API Response unsuccessful:", result.data);
                setUsersData([]);
                const errorMessage = result.data?.message || "Error fetching users. Please try again.";
                alert(errorMessage);
            }
        } catch (error) {
            console.error("=== API Error ===");
            console.error("Error details:", error);
            console.error("Error response:", error.response?.data);
            console.error("Error status:", error.response?.status);

            setUsersData([]);

            if (error.response?.status === 401) {
                alert("Session expired. Please login again.");
                navigate("/mapLogin");
            } else if (error.response?.data?.message) {
                alert(`Error: ${error.response.data.message}`);
            } else {
                alert("Error fetching users. Please check your connection and try again.");
            }
        } finally {
            setIsFetching(false);
        }
    };

    function closeViewModal() {
        setShowViewModal(false);
        setViewData(null);
    }

    function handleViewData(userData) {
        try {
            // Debug: Log the raw user data to see what fields are available
            console.log("Raw user data for view modal:", userData);
            console.log("Available district fields:", {
                districtName: userData.districtName,
                districtNames: userData.districtNames,
                distName: userData.distName
            });
            console.log("Available block fields:", {
                blockName: userData.blockName,
                blockNames: userData.blockNames,
                blockNameList: userData.blockNameList,
                userRoleCode: userData.userRoleCode
            });

            // Safely determine gender
            let gender = "Not Specified";
            if (userData.gender) {
                const genderChar = userData.gender.toString().charAt(0).toUpperCase();
                if (genderChar === "M") {
                    gender = "Male";
                } else if (genderChar === "F") {
                    gender = "Female";
                } else if (genderChar === "T") {
                    gender = "Other";
                }
            }

            // Safe access to user data with fallbacks
            const safeUserData = {
                userName: userData.userName || "N/A",
                emailId: userData.emailId || "N/A",
                userMobile: userData.userMobile || "N/A",
                userID: userData.userID || "N/A",
                userPassword: userData.userPassword || "****",
                isVisible: userData.isVisible || "N/A",
                isActive: userData.isActive || "N/A",
                desigName: userData.desigName || "N/A",
                schemeName: userData.schemeName || "N/A",
                stateName: userData.stateName || "N/A",
                atariName: userData.atariName || "N/A",
                districtName: userData.districtNames || userData.districtName || userData.distName || "N/A", // Try multiple possible field names
                subDistrictName: userData.subDistrictName || userData.subDistName || "N/A",
                blockName: userData.blockName || userData.blockNames || userData.blockNameList || "N/A", // Priority: blockName first
                fmttiName: userData.fmttiName || "N/A",
                fmtcName: userData.fmtcName || "N/A",
                gender: gender,
                address: userData.address || "N/A",
                userTypeCode: userData.userTypeCode || "N/A",
                userType: userData.userRoleCode || "N/A",
                isMobileVerified: userData.isMobileVerified || "N/A",
                isEmailVerified: userData.isEmailVerified || "N/A",
                createdOn: userData.createdOn ? new Date(userData.createdOn).toLocaleDateString() : "N/A",
                // Handle multiple districts and blocks
                hasMultipleDistricts: false,
                hasMultipleBlocks: false
            };

            // Check if user has multiple districts (comma-separated)
            if (safeUserData.districtName && safeUserData.districtName !== "N/A") {
                const districts = safeUserData.districtName.split(',').map(d => d.trim()).filter(d => d);
                if (districts.length > 1) {
                    safeUserData.hasMultipleDistricts = true;
                    safeUserData.districtList = districts;
                    console.log("User has multiple districts:", districts);
                }
            }

            // Check if user has multiple blocks (handle both simple and complex formats)
            if (safeUserData.blockName && safeUserData.blockName !== "N/A") {
                let allBlocks = [];
                
                // First check if blockCode has pipes to identify district grouping
                if (userData.blockCode && userData.blockCode.includes('|')) {
                    // Parse blockCode to get district groups
                    const blockCodeGroups = userData.blockCode.split('|').filter(group => group.trim());
                    // Parse blockName into individual items
                    const blockNameArray = safeUserData.blockName.split(',').map(b => b.trim()).filter(b => b);
                    
                    // Count total codes to verify match with names
                    let totalCodes = 0;
                    blockCodeGroups.forEach(group => {
                        totalCodes += group.split(',').filter(c => c.trim()).length;
                    });
                    
                    console.log("Block Code/Name mapping:", {
                        blockCode: userData.blockCode,
                        blockName: safeUserData.blockName,
                        totalCodes: totalCodes,
                        totalNames: blockNameArray.length,
                        match: totalCodes === blockNameArray.length
                    });
                    
                    // Only use blockCode pipe structure if counts match
                    if (totalCodes === blockNameArray.length) {
                        // Reconstruct the district-grouped structure
                        let currentIndex = 0;
                        blockCodeGroups.forEach((codeGroup, groupIndex) => {
                            const codesInGroup = codeGroup.split(',').filter(c => c.trim());
                            
                            // Map codes to names (assuming they're in the same order)
                            for (let i = 0; i < codesInGroup.length && currentIndex < blockNameArray.length; i++) {
                                allBlocks.push(blockNameArray[currentIndex]);
                                currentIndex++;
                            }
                        });
                    } else {
                        // Counts don't match - just parse blockName directly to show all available names
                        console.warn(`Count mismatch: ${totalCodes} codes vs ${blockNameArray.length} names. Using all available names.`);
                        allBlocks = blockNameArray;
                    }
                } else {
                    // Handle simple comma-separated format (no pipe groups in blockCode)
                    const blockNames = safeUserData.blockName.split(',').map(b => b.trim()).filter(b => b);
                    if (userData.blockCode) {
                        const codeCount = userData.blockCode
                            .split(',')
                            .map(c => c.trim())
                            .filter(c => c).length;

                        console.log("Block Code/Name mapping (no pipes):", {
                            blockCode: userData.blockCode,
                            blockName: safeUserData.blockName,
                            totalCodes: codeCount,
                            totalNames: blockNames.length,
                            match: codeCount === blockNames.length
                        });

                        if (codeCount === blockNames.length) {
                            allBlocks = blockNames;
                        } else {
                            console.warn(`Count mismatch (no pipes): ${codeCount} codes vs ${blockNames.length} names.`);
                            // If more names than codes, trim extras to avoid over-reporting
                            if (codeCount && blockNames.length > codeCount) {
                                allBlocks = blockNames.slice(0, codeCount);
                            } else {
                                // If fewer names than codes, show available names without fabricating
                                allBlocks = blockNames;
                            }
                        }
                    } else {
                        allBlocks = blockNames;
                    }
                }
                
                if (allBlocks.length > 1) {
                    safeUserData.hasMultipleBlocks = true;
                    safeUserData.blockList = allBlocks;
                }
            }

            // Check if this is scheme 16 (M&T) with complex state structure

            if (sessionStorage.getItem("schemeCodeModel") === "16" && userData.states && Array.isArray(userData.states) && userData.surveyor) {
                // Handle complex state/district structure
                let datastatename = userData.states.map(item => item.stateName || "N/A").join(', ');
                const districtNamesArray = [];
                const subDistrictNamesArray = [];
                const blockNamesArray = [];

                userData.states.forEach(state => {
                    if (state.districts && Array.isArray(state.districts)) {
                        state.districts.forEach(district => {
                            districtNamesArray.push(district.districtName || "N/A");
                            if (district.subDistricts && Array.isArray(district.subDistricts)) {
                                district.subDistricts.forEach(subDistrict => {
                                    subDistrictNamesArray.push(subDistrict.subDistrictName || "N/A");
                                    // Handle blocks within sub-districts
                                    if (subDistrict.blocks && Array.isArray(subDistrict.blocks)) {
                                        subDistrict.blocks.forEach(block => {
                                            blockNamesArray.push(block.blockName || "N/A");
                                        });
                                    }
                                });
                            }
                            // Handle blocks directly within districts
                            if (district.blocks && Array.isArray(district.blocks)) {
                                district.blocks.forEach(block => {
                                    blockNamesArray.push(block.blockName || "N/A");
                                });
                            }
                        });
                    }
                });

                let districtNamesArrays = districtNamesArray.join(', ') || "N/A";
                let subdistrictNamesArrays = subDistrictNamesArray.join(', ') || "N/A";
                let blockNamesArrays = blockNamesArray.join(', ') || "N/A";

                safeUserData.datastatename = datastatename;
                safeUserData.districtNamesArrays = districtNamesArrays;
                safeUserData.subdistrictNamesArrays = subdistrictNamesArrays;
                safeUserData.blockNamesArrays = blockNamesArrays;
                safeUserData.isComplexStructure = true;
            } else {
                safeUserData.isComplexStructure = false;
            }

            setViewData(safeUserData);
            setShowViewModal(true);
        } catch (error) {
            console.error("Error in handleViewData function:", error);
            alert("Unable to load user details. Please try again.");
        }
    }

    async function deleteData() {
        try {
            const baseUrl = process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE;

            const response = await axios({
                method: 'delete',
                url: `${baseUrl}/api/MT/Users`,
                headers: {
                    'accept': '*/*',
                    'Content-Type': 'application/json'
                },
                data: {
                    modifiedByUC: parseInt(sessionStorage.getItem("userCodeModel")),
                    userCode: deleteCode.userCode
                }
            });
            if (response.data && response.data.success === true) {
                alert("User deleted successfully!");
                // Reload the page to refresh the data
                window.location.reload();
            } else {
                alert(response.data.message || "Failed to delete user");
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert("Error deleting user. Please try again.");
        }
    }

    function handleEmail(originalRow) {

    }

    function handleUserRole(originalRow) {
        let userRoleCode = originalRow.userRoleCode;

        if (userRoleCode === 1) {
            return "Central"
        } else if (userRoleCode === 7) {
            return "State"
        } else if (userRoleCode === 3) {
            return "District"
        } else if (userRoleCode === 4) {
            return "Sub-District"
        } else if (userRoleCode === 5) {
            return "Surveyor"
        }
    }

    const handleExportData = (table) => {
        // Get user role from session storage first
        const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
        
        // Define the columns we want to export in order
        const exportColumns = [
            { header: 'S.No', key: null },
           // { header: 'Component', key: 'userTypeCode' },
            { header: 'User Type', key: 'userRoleCode' },
            { header: 'Mobile/User ID', key: 'userMobile' },
            { header: 'Email Id', key: 'emailId' },
            { header: 'Designation', key: 'desigName' },
            { header: 'User Name', key: 'userName' },
            { header: 'Gender', key: 'gender' },
            { header: 'Address', key: 'address' },
            { header: 'State', key: 'stateName' },
            { header: 'Districts', key: 'districtNames' },
            // Add Blocks column for district users and surveyors
            ...(userRoleCode === "3" || userRoleCode === "5" ? [{ header: 'Blocks', key: 'blockNames' }] : [])
        ];

        // Get all rows, not just the current page
        const allRows = usersData;

        // Transform data according to defined columns
        const filteredData = allRows.map((originalRow, index) => {
            const rowData = {};
            exportColumns.forEach(column => {
                if (column.header === 'S.No') {
                    rowData['S.No'] = index + 1;
                } else if (column.header === 'Component' && column.key === 'userTypeCode') {
                    const userTypeCode = originalRow.userTypeCode;
                    let componentName = '';
                    switch(userTypeCode) {
                        case 1:
                            componentName = "FMTTI";
                            break;
                        case 2:
                            componentName = "CRM";
                            break;
                        case 3:
                            componentName = "SMAM";
                            break;
                        default:
                            componentName = "";
                    }
                    rowData['Component'] = componentName;
                } else if (column.header === 'User Type') {
                    // Get user type based on userRoleCode
                    const userRoleCode = originalRow.userRoleCode;
                    let userType = '';
                    switch(userRoleCode) {
                        case 1:
                            userType = "Central";
                            break;
                        case 2:
                            userType = "State";
                            break;
                        case 3:
                            userType = "District";
                            break;
                        case 4:
                            userType = "Block";
                            break;
                        case 5:
                            userType = "Surveyor";
                            break;
                        case 6:
                            userType = "FMTTI";
                            break;
                        case 7:
                            userType = "FMTC";
                            break;
                        case 8:
                            userType = "FMTTI_Surveyor";
                            break;
                        case 9:
                            userType = "ICAR";
                            break;
                        case 10:
                            userType = "Atari";
                            break;
                        case 11:
                            userType = "KVK";
                            break;
                        case 12:
                            userType = "CRM_Surveyor";
                            break;
                    }
                    rowData['User Type'] = userType;
                } else if (column.header === 'Districts') {
                    // Handle multiple districts for export
                    const districtNames = originalRow.districtNames || originalRow.districtName || '';
                    rowData['Districts'] = districtNames;
                } else if (column.header === 'Blocks') {
                    // Handle multiple blocks for export - priority order: blockName, blockNames, blockNameList
                    const blockNames = originalRow.blockName || originalRow.blockNames || originalRow.blockNameList || '';
                    // Export blockNames as comma-separated (blockName from API doesn't contain pipes)
                    rowData['Blocks'] = blockNames;
                } else if (column.key) {
                    rowData[column.header] = originalRow[column.key] || '';
                }
            });
            return rowData;
        });
        // Map role codes to readable names for filename
        let roleText = "All";
        let allowed;
        // Map role codes to readable names
        switch(userRoleCode) {
            case "1":
                roleText = "Central";
                break;
            case "2":
                roleText = "State";
                break;
            case "3":
                roleText = "District";
                break;
            case "4":
                roleText = "SubDistrict";
                break;
            case "6":
                roleText = "FMTTI";
                break;
            case "7":
                roleText = "FMTC";
                break;
            case "8":
                roleText = "FMTTI_Surveyor";
                break;
            case "9":
                roleText = "ICAR";
                break;
            case "10":
                roleText = "KVK";
                break;

        }

        const currentDate = new Date().toISOString().split('T')[0];
        const fileName = `UsersList_${roleText}_${currentDate}`;

                const headers = exportColumns.map(col => col.header);

        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: headers,
            filename: fileName + '.csv', // Add .csv extension
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(filteredData);
    };

    function handleEdit(userData) {
        setEditData(userData);
        setShowEditModal(true);
    }

    function closeEditModal() {
        setShowEditModal(false);
        setEditData(null);
    }

    async function handleUpdate() {
        if (!editData) return;

        // Validate mobile number
        const mobileNumber = editData.userMobile;
        if (!mobileNumber || mobileNumber.length !== 10) {
            alert("Please enter a valid 10-digit mobile number");
            return;
        }

        try {
            const baseUrl = process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE;

            const response = await axios({
                method: 'put',
                url: `${baseUrl}/api/MT/Users`,
                headers: {
                    'accept': '*/*',
                    'Content-Type': 'application/json'
                },
                data: {
                    modifiedByUC: parseInt(sessionStorage.getItem("userCodeModel")),
                    userName: editData.userName,
                    userId: editData.userMobile,
                    mobile: editData.userMobile,
                    emailId: editData.emailId,
                    gender: editData.gender,
                    address: editData.address,
                    isActive: editData.isActive
                }
            });

            if (response.data && response.data.success === true) {
                alert("User updated successfully!");
                closeEditModal();
                fetchData();
            } else {
                alert(response.data.message || "Failed to update user");
            }
        } catch (error) {
            console.error("Update error:", error);
            alert("Error updating user. Please try again.");
        }
    }

    // Get user role from session storage
    const userRoleCode = sessionStorage.getItem("userRoleCodeModel");

    const columns = useMemo(
        () => {
            const baseColumns = [
            {
                accessor: '',
                header: 'Actions',
                Cell: ({ row }) => (
                    <>
                        <i className="btn text-success" type="button" onClick={() => handleViewData(row.original)}>
                            <FontAwesomeIcon icon={faEye} />
                        </i>
                        <i className="btn text-primary" type="button" onClick={() => handleEdit(row.original)}>
                            <FontAwesomeIcon icon={faPencil} />
                        </i>
                        <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user"
                           onClick={() => setDeleteCode({ userCode: row.original.userCode })}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </i>
                    </>
                ),
                size: 100,
                enableResizing: false,
                muiTableHeadCellProps: {
                    sx: { padding: '8px 4px' }
                },
                muiTableBodyCellProps: {
                    sx: { padding: '8px 4px' }
                }
            },
            {
                accessorFn: (row) => {
                    const userTypeCode = parseInt(row.userTypeCode);
                    switch(userTypeCode) {
                        case 1: return "FMTTI";
                        case 2: return "CRM";
                        case 3: return "SMAM";
                        default: return "N/A";
                    }
                },
                id: 'userTypeCode',
                header: 'Component Name',
                size: 110
            },
            {
                accessorFn: (row) => {
                    const userRoleCode = parseInt(row.userRoleCode);
                    switch(userRoleCode) {
                        case 1: return "Central";
                        case 2: return "State";
                        case 3: return "District";
                        case 4: return "Sub-District";
                        case 5: return "Surveyor";
                        case 6: return "FMTTI";
                        case 7: return "FMTC";
                        case 8: return "FMTTI_Surveyor";
                        case 9: return "ICAR";
                        case 10: return "Atari";
                        case 11: return "KVK";
                        case 12: return "CRM_Surveyor";
                        default: return "N/A";
                    }
                },
                id: 'userRoleCode',
                header: 'User Type',
                size: 110
            },
            {
                accessorKey: 'userMobile',
                header: 'Mobile/User ID',
                size: 150
            },
            {
                accessorKey: 'emailId',
                header: 'Email Id',
                Cell: ({ cell }) => (
                    <span style={{ textTransform: 'none' }}>{cell.getValue()}</span>
                ),
                size: 200
            },
            // {
            //     accessorKey: 'desigName',
            //     header: 'Designation',
            //     size: 150
            // },
            {
                accessorKey: 'userName',
                header: 'User Name',
                size: 150
            },
            // {
            //     accessorKey: 'gender',
            //     header: 'Gender',
            //     Cell: ({ cell }) => {
            //         const genderValue = cell.getValue();
            //         switch(genderValue) {
            //             case 'M':
            //                 return 'Male';
            //             case 'F':
            //                 return 'Female';
            //             case 'T':
            //                 return 'Other';
            //             default:
            //                 return 'N/A';
            //         }
            //     },
            //     size: 100
            // },
            // {
            //     accessorKey: 'address',
            //     header: 'Address',
            //     size: 300
            // },
            // Conditionally add State column - Show for Central users (role 1) and State users (role 2)
            ...(userRoleCode === "1" || userRoleCode === "2" ? [{
                accessorKey: 'stateName',
                header: 'State',
                size: 150
            }] : []),

            // Conditionally add District column - Show for all users except Central (role 1)
            ...(userRoleCode !== "1" ? [{
                accessorKey: 'districtNames',
                header: 'Districts',
                Cell: ({ cell, row }) => {
                    const districtNames = cell.getValue() || row.original.districtName || 'N/A';
                    // Handle comma-separated district names
                    if (districtNames && districtNames !== 'N/A') {
                        const districts = districtNames.split(',').map(d => d.trim());
                        if (districts.length > 1) {
                            return (
                                <span title={districtNames}>
                                    {districts.length > 2
                                        ? `${districts.slice(0, 2).join(', ')} +${districts.length - 2} more`
                                        : districtNames
                                    }
                                </span>
                            );
                        }
                    }
                    return districtNames || 'N/A';
                },
                size: 180
            }] : []),

            // Conditionally add Blocks column - Show for District users (role 3) and Surveyor users (role 5)
            ...(userRoleCode === "3" || userRoleCode === "5" ? [{
                accessorKey: 'blockNames',
                header: 'Blocks',
                Cell: ({ cell, row }) => {
                    // Priority order: blockName (most common), then blockNames, then blockNameList
                    const blockNames = row.original.blockName || cell.getValue() || row.original.blockNames || row.original.blockNameList || 'N/A';
                    
                    if (blockNames && blockNames !== 'N/A') {
                        // Handle simple comma-separated format (blockName from API doesn't contain pipes)
                        const blocks = blockNames.split(',').map(b => b.trim()).filter(b => b);
                        if (blocks.length > 1) {
                            return (
                                <span title={blocks.join(', ')}>
                                    {blocks.length > 2
                                        ? `${blocks.slice(0, 2).join(', ')} +${blocks.length - 2} more`
                                        : blocks.join(', ')
                                    }
                                </span>
                            );
                        } else if (blocks.length === 1) {
                            return blocks[0];
                        }
                    }
                    return blockNames || 'N/A';
                },
                size: 200
            }] : []),
            // {
            //     accessorKey: 'createdOn',
            //     header: 'Created On',
            //     Cell: ({ cell }) => {
            //         const date = cell.getValue();
            //         return date ? new Date(date).toLocaleDateString() : 'N/A';
            //     },
            //     size: 120
            // },
            // {
            //     accessorKey: 'schemeName',
            //     header: 'Scheme',
            //     size: 150
            // },
            // {
            //     accessorKey: 'fmttiName',
            //     header: 'FMTTI',
            //     size: 130,
            //     Cell: ({ cell }) => cell.getValue() || 'N/A'
            // },
            // {
            //     accessorKey: 'fmtcName',
            //     header: 'FMTC',
            //     size: 130,
            //     Cell: ({ cell }) => cell.getValue() || 'N/A'
            // },
            // {
            //     accessorKey: 'desigName',
            //     header: 'Designation',
            //     size: 150,
            //     Cell: ({ cell }) => cell.getValue() || 'N/A'
            // }
            ];
            return baseColumns;
        },
        [userRoleCode] // Added userRoleCode as dependency
    );

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarMnt />
            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    <nav>
                        <h1>Users List</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Users</li>
                            <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                            <li className="breadcrumb-item">
                                {(() => {
                                    const userTypeCode = Number(sessionStorage.getItem("userTypeCodeModel"));
                                    switch(userTypeCode) {
                                        case 1: return "FMTTI";
                                        case 2: return "CRM";
                                        case 3: return "SMAM";
                                        default: return "";
                                    }
                                })()}
                            </li>
                        </ol>
                    </nav>
                    {/* <div className="d-flex gap-2">
                        {(() => {
                            const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
                            const userTypeCode = sessionStorage.getItem("userTypeCodeModel");

                            console.log("Add User Button - userRoleCode:", userRoleCode, "userTypeCode:", userTypeCode);

                            // Show appropriate Add User button based on user role
                            if (userRoleCode === "1") {
                                // Central users can add any type of user
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => navigate("/MNT/AdmLogin")}
                                    >
                                        Add New User
                                    </button>
                                );
                            } else if (userRoleCode === "2") {
                                // State users can add district users
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => navigate("/MNT/StateUser")}
                                    >
                                        Add District User
                                    </button>
                                );
                            } else if (userRoleCode === "3") {
                                // District users can add sub-district users
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => navigate("/MNT/DistrictUserCreation")}
                                    >
                                        Add Sub-District User
                                    </button>
                                );
                            } else if (userRoleCode === "6") {
                                // FMTTI users can add FMTC users
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => navigate("/MNT/FmtcUserCreation")}
                                    >
                                        Add FMTC User
                                    </button>
                                );
                            } else if (userRoleCode === "7") {
                                // FMTC users can add FMTC Surveyors
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => navigate("/MNT/FmttisurveyorCreation")}
                                    >
                                        Add FMTC Surveyor
                                    </button>
                                );
                            }
                            else if (userRoleCode === "9") {
                                // FMTC users can add FMTC Surveyors
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => navigate("/MNT/ICARUserCreation")}
                                    >
                                        Add ICAR User
                                    </button>
                                );
                            }
                            else if (userRoleCode === "10") {
                                // FMTC users can add FMTC Surveyors
                                return (
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() => navigate("/MNT/KvkUserCreation")}
                                    >
                                        Add KVK Surveyor
                                    </button>
                                );
                            }
                            return null;
                        })()}
                    </div> */}
                </div>

                <section className="section">
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">
                            <div className="card">
                                <MaterialReactTable
                                    columns={columns}
                                    data={usersData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                    enableColumnActions={false}
                                    enableDensityToggle={false}
                                    enableFullScreenToggle={false}
                                    enableColumnResizing
                                    enableHiding
                                    enableColumnFilters
                                    enableGlobalFilter
                                    enableStickyHeader
                                    initialState={{ 
                                        pagination: { 
                                            pageSize: 10,
                                            pageIndex: 0 
                                        },
                                        showGlobalFilter: true,
                                        columnVisibility: {
                                            address: false,
                                            fmttiName: false,
                                            fmtcName: false
                                        }
                                    }}
                                    muiTablePaginationProps={{
                                        rowsPerPageOptions: [5, 10, 20, 50, 100],
                                        showFirstButton: true,
                                        showLastButton: true,
                                    }}
                                    defaultColumn={{
                                        minSize: 100,
                                        maxSize: 400,
                                        size: 150,
                                    }}
                                    muiTableProps={{
                                        sx: {
                                            tableLayout: 'fixed',
                                            '& .MuiTableCell-root': {
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                padding: '8px 4px',
                                            },
                                        },
                                    }}
                                    muiTableHeadProps={{
                                        sx: {
                                            '& .MuiTableCell-root': {
                                                backgroundColor: '#f5f5f5',
                                                fontWeight: 'bold',
                                            },
                                        },
                                    }}

                                    state={{ 
                                        isLoading: isFetching ? true : false,
                                        showProgressBars: isFetching,
                                    }}
                                    muiLinearProgressProps={{
                                        color: 'primary',
                                        variant: 'indeterminate',
                                        sx: { display: isFetching ? 'block' : 'none' }
                                    }}
                                    enableRowNumbers
                                    positionPagination="bottom"
                                    rowNumberDisplayMode="static"
                                    renderRowNumberCell={({ row }) => (
                                        <div style={{ textAlign: 'center' }}>
                                            {Number(row.id) + 1}
                                        </div>
                                    )}
                                    displayColumnDefOptions={{
                                        'mrt-row-numbers': {
                                            enableColumnOrdering: false,
                                            enableColumnActions: false,
                                            size: 40,
                                            Header: () => <div style={{ textAlign: 'center' }}>S.No</div>,
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    padding: '8px 0px',
                                                }
                                            },
                                            muiTableBodyCellProps: {
                                                sx: {
                                                    padding: '8px 0px',
                                                }
                                            }
                                        }
                                    }}
                                    renderTopToolbarCustomActions={({ table }) => (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "1rem",
                                                p: "0.5rem",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            <Button
                                                color="primary"
                                                onClick={() => handleExportData(table)}
                                                startIcon={<FileDownloadIcon />}
                                                variant="contained"
                                            >
                                                Export in CSV
                                            </Button>
                                        </Box>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <div className="modal fade" id="staticBackdrop_user" data-bs-backdrop="staticBackdrop_user" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body">
                            <h6 id="deleteHeading">Are you sure you want to delete this record?</h6>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                            <button type="button" className="btn border" data-bs-dismiss="modal">No</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* View User Modal */}
            {showViewModal && viewData && (
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2>View User Details</h2>
                                <button type="button" className="btn-close" onClick={closeViewModal}>×</button>
                            </div>
                            <div className="modal-body">
                                <h5 className="formgrouping">User Details</h5>
                                <div className="row">
                                    <div className="col-md-4">
                                        <h6>User Name</h6>
                                        <p>{viewData.userName}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Email Id</h6>
                                        <p>{viewData.emailId}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Mobile No.</h6>
                                        <p>{viewData.userMobile}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Gender</h6>
                                        <p>{viewData.gender}</p>
                                    </div>
                                    {/* Show Address field only for ICAR users (userRoleCode = 9) */}
                                    {sessionStorage.getItem("userRoleCodeModel") === "9" && (
                                        <div className="col-md-4">
                                            <h6>Address</h6>
                                            <p>{viewData.address}</p>
                                        </div>
                                    )}
                                </div>

                                <h5 className="formgrouping">User Credential</h5>
                                <div className="row">
                                    <div className="col-md-3">
                                        <h6>User Id</h6>
                                        <p>{viewData.userMobile}</p>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Password</h6>
                                        <div className="d-flex align-items-center">
                                            <span id="password-text" style={{letterSpacing: '2px', marginRight: '8px'}}>••••••••</span>
                                            <span id="real-password" style={{display: 'none', marginRight: '8px'}}>{viewData.userPassword}</span>
                                            <button
                                                id="toggle-password"
                                                style={{border: 'none', background: 'none', cursor: 'pointer', fontSize: '16px'}}
                                                onClick={() => {
                                                    const passwordText = document.getElementById('password-text');
                                                    const realPassword = document.getElementById('real-password');
                                                    const toggleButton = document.getElementById('toggle-password');

                                                    if (passwordText.style.display === 'none') {
                                                        // Show dots, hide real password
                                                        passwordText.style.display = 'inline';
                                                        realPassword.style.display = 'none';
                                                        toggleButton.innerHTML = '👁️';
                                                    } else {
                                                        // Show real password, hide dots
                                                        passwordText.style.display = 'none';
                                                        realPassword.style.display = 'inline';
                                                        toggleButton.innerHTML = '🙈';
                                                    }
                                                }}
                                            >
                                                👁️
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Is Visible</h6>
                                        <p>{viewData.isVisible}</p>
                                    </div>
                                    <div className="col-md-3">
                                        <h6>Is Active</h6>
                                        <p>{viewData.isActive}</p>
                                    </div>
                                </div>

                                <h5 className="formgrouping">Official Details</h5>
                                <div className="row">
                                    <div className="col-md-4">
                                        <h6>Designation Name</h6>
                                        <p>{viewData.desigName}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Scheme Name</h6>
                                        <p>{viewData.schemeName}</p>
                                    </div>
                                    {/* Show FMTTI field only for FMTTI users (userTypeCode = 1) */}
                                    {viewData.userTypeCode === "1" && (
                                        <div className="col-md-4">
                                            <h6>FMTTI</h6>
                                            <p>{viewData.fmttiName}</p>
                                        </div>
                                    )}
                                    {/* Show FMTC field only for FMTTI users (userTypeCode = 1) */}
                                    {viewData.userTypeCode === "1" && (
                                        <div className="col-md-4">
                                            <h6>FMTC</h6>
                                            <p>{viewData.fmtcName}</p>
                                        </div>
                                    )}
                                    {/* Show location fields based on component type */}
                                    {(viewData.userTypeCode === "2" || viewData.userTypeCode === "3") && (
                                        <>
                                            {viewData.isComplexStructure ? (
                                                <>
                                                    <div className="col-md-4">
                                                        <h6>{sessionStorage.getItem("userRoleCodeModel") === "9" ? "Atari Names" : "States"}</h6>
                                                        <p>{sessionStorage.getItem("userRoleCodeModel") === "9" ? viewData.atariName : viewData.datastatename}</p>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <h6>Districts</h6>
                                                        <p>{viewData.districtNamesArrays}</p>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <h6>SubDistricts</h6>
                                                        <p>{viewData.subdistrictNamesArrays}</p>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <h6>Blocks</h6>
                                                        <p>{viewData.blockNamesArrays}</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="col-md-4">
                                                        <h6>{sessionStorage.getItem("userRoleCodeModel") === "9" ? "Atari Name" : "State Name"}</h6>
                                                        <p>{sessionStorage.getItem("userRoleCodeModel") === "9" ? viewData.atariName : viewData.stateName}</p>
                                                    </div>
                                                    {viewData.districtName && viewData.districtName !== "N/A" && (
                                                        <div className={viewData.hasMultipleDistricts ? "col-md-12" : "col-md-4"}>
                                                            <h6>District Name{viewData.hasMultipleDistricts ? 's' : ''}</h6>
                                                            {viewData.hasMultipleDistricts ? (
                                                                <div>
                                                                    {viewData.districtList.map((district, index) => (
                                                                        <span key={index} className="badge bg-primary me-1 mb-1">
                                                                            {district}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <p>{viewData.districtName}</p>
                                                            )}
                                                        </div>
                                                    )}
                                                    {viewData.subDistrictName && viewData.subDistrictName !== "N/A" && (
                                                        <div className="col-md-4">
                                                            <h6>SubDistrict Name</h6>
                                                            <p>{viewData.subDistrictName}</p>
                                                        </div>
                                                    )}
                                                    {(viewData.blockName && viewData.blockName !== "N/A") || viewData.userType === "5" ? (
                                                        <div className={viewData.hasMultipleBlocks ? "col-md-12" : "col-md-4"}>
                                                            <h6>Block Name{viewData.hasMultipleBlocks ? 's' : ''}</h6>
                                                            {viewData.hasMultipleBlocks ? (
                                                                <div>
                                                                    {viewData.blockList.map((block, index) => (
                                                                        <span key={index} className="badge bg-success me-1 mb-1">
                                                                            {block}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <p>{viewData.blockName || "N/A"}</p>
                                                            )}
                                                        </div>
                                                    ) : null}
                                                </>
                                            )}
                                        </>
                                    )}
                                    {viewData.villageName && (
                                        <div className="col-md-12">
                                            <h6>Village Name</h6>
                                            <p>{viewData.villageName}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeViewModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit User Modal */}
            {showEditModal && editData && (
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2>Edit User</h2>
                                <button type="button" className="btn-close" onClick={closeEditModal}>×</button>
                            </div>
                            <div className="modal-body">
                                <form className="row g-3">
                                    <div className="col-md-6">
                                        <label htmlFor="userName" className="form-label">User Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="userName"
                                            value={editData.userName || ''}
                                            onChange={(e) => setEditData({...editData, userName: e.target.value})}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="userMobile" className="form-label">User ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="userMobile"
                                            value={editData.userMobile || editData.userMobile || ''}
                                            onChange={(e) => setEditData({...editData, userMobile: e.target.value})}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="mobile" className="form-label">Mobile</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="mobile"
                                            value={editData.mobile || editData.userMobile || ''}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                                if (value.length <= 10) {
                                                    setEditData({...editData, mobile: value});
                                                }
                                            }}
                                            onBlur={(e) => {
                                                const value = e.target.value;
                                                if (value && value.length !== 10) {
                                                    e.target.style.borderColor = "red";
                                                } else if (value.length === 10) {
                                                    e.target.style.borderColor = "green";
                                                } else {
                                                    e.target.style.borderColor = "";
                                                }
                                            }}
                                            placeholder="Enter 10-digit mobile number"
                                            maxLength="10"
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="emailId" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="emailId"
                                            value={editData.emailId || ''}
                                            onChange={(e) => setEditData({...editData, emailId: e.target.value})}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="gender" className="form-label">Gender</label>
                                        <select
                                            className="form-select"
                                            id="gender"
                                            value={editData.gender || 'M'}
                                            onChange={(e) => setEditData({...editData, gender: e.target.value})}
                                        >
                                            <option value="M">Male</option>
                                            <option value="F">Female</option>
                                            <option value="T">Other</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="isActive" className="form-label">Status</label>
                                        <select
                                            className="form-select"
                                            id="isActive"
                                            value={editData.isActive || 'Y'}
                                            onChange={(e) => setEditData({...editData, isActive: e.target.value})}
                                        >
                                            <option value="Y">Active</option>
                                            <option value="N">Inactive</option>
                                        </select>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={handleUpdate}>Save</button>
                                <button type="button" className="btn btn-secondary" onClick={closeEditModal}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <AdminFooterNew />
        </>
    );
};

export default UsrListMnT;